import { gql } from '@apollo/client'

export const Dig = gql`
    query Dig($roomId: ID!, $tags: String!, $scored: Boolean, $limit: Int) {
        dig(roomId: $roomId, tags: $tags, scored: $scored, limit: $limit) {
            id
            album
            artist
            bitRate
            codec
            composer
            completed
            contributors {
                id
                username
            }
            coverArt {
                full
                thumb250
                thumb500
                thumb1200
            }
            created
            date
            duration
            files {
                bitRate
                duration
                key
                size
            }
            genre
            roomId
            size
            tags
            title
            track
            updated
            userId
            youtubeId
        }
    }
`

export default Dig

